import { Header } from '@tanstack/react-table';
import classnames from 'classnames';
import * as React from 'react';

import styles from '../../Table.module.scss';
import { useTableContext } from '../../TableContext';
import { SelectAllCheckbox } from '../SelectAllCheckbox';
import { TableFilter } from '../TableFilter';

type TableFiltersProps = {
  selectAllLabel?: string;
};

export function TableFilters<TData>({ selectAllLabel }: TableFiltersProps) {
  const { name: tableName, getTable, isSelectable } = useTableContext<TData>();

  const headerGroups = getTable()?.getHeaderGroups() || [];

  return headerGroups.map((group) => (
    <tr key={group.id}>
      {isSelectable && (
        <td
          className={classnames(styles.selectAllCol, {
            [styles.withLabel]: selectAllLabel === undefined || selectAllLabel?.length,
          })}
          data-testid="select-all-checkbox"
          width={selectAllLabel === undefined || selectAllLabel?.length > 0 ? '140' : undefined}>
          <SelectAllCheckbox label={selectAllLabel ?? 'Select All'} />
        </td>
      )}

      {group.headers.map((header) => (
        <TableFilter
          header={header as Header<TData, unknown>}
          key={`filter-${header.id}`}
          name={`${tableName}-filter-${header.id}`}
        />
      ))}
    </tr>
  ));
}
